import styled, { css } from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

// Shared by SizeChartSizeTable.styles.tsx and SizeChartFitGuideSection.styles.tsx

export const cellText = css`
  ${TypeStyle.css.bodyNano}
`

export const dataCellText = css`
  ${cellText};
  color: ${o => o.theme.color.text.primary.on.background};
  font-weight: 500;
`

export const tableCell = css`
  height: 17px;
  padding: ${o => o.theme.spacing(3, 4)};
  text-align: start;
  vertical-align: middle;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`

// Shared by SizeChartModalContent.styles.tsx and SizeChartSizingSection.styles.tsx

export const sectionGap = css`
  gap: ${o => o.theme.spacing(5)};

  ${fromMd} {
    gap: ${o => o.theme.spacing(6)};
  }
`
